/**
 * Enhanced Cart Functionality
 * Handles quantity updates, free shipping progress, gift message toggle, and recommendations
 */

(function() {
  'use strict';

  // Cart quantity update handlers
  function initQuantityControls() {
    const cartForm = document.getElementById('cart-form');
    if (!cartForm) return;

    // Quantity button handlers
    const qtyButtons = document.querySelectorAll('.labratgifts-cart-item__qty-btn');
    qtyButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const line = this.dataset.line;
        const qty = parseInt(this.dataset.qty);
        updateCartQuantity(line, qty);
      });
    });

    // Direct input change
    const qtyInputs = document.querySelectorAll('.labratgifts-cart-item__qty-input');
    qtyInputs.forEach(input => {
      input.addEventListener('change', function() {
        const line = this.dataset.line;
        const qty = parseInt(this.value);
        if (qty > 0) {
          updateCartQuantity(line, qty);
        }
      });
    });
  }

  // Update cart quantity via AJAX
  function updateCartQuantity(line, quantity) {
    const formData = {
      'line': line,
      'quantity': quantity
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      // Reload page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      alert('Error updating cart. Please try again.');
    });
  }

  // Free shipping progress bar animation
  function initShippingProgress() {
    const progressBar = document.querySelector('.labratgifts-cart__progress-fill');
    if (!progressBar) return;

    // Animate on load
    const targetWidth = progressBar.style.width;
    progressBar.style.width = '0%';
    setTimeout(() => {
      progressBar.style.width = targetWidth;
    }, 100);
  }

  // Gift message toggle
  function initGiftMessage() {
    const giftCheckbox = document.querySelector('input[name="attributes[gift]"]');
    const giftMessage = document.querySelector('.labratgifts-cart__gift-message');
    
    if (!giftCheckbox || !giftMessage) return;

    giftCheckbox.addEventListener('change', function() {
      if (this.checked) {
        giftMessage.style.display = 'block';
      } else {
        giftMessage.style.display = 'none';
      }
    });
  }

  // Quick add to cart from recommendations
  function initRecommendationQuickAdd() {
    const addForms = document.querySelectorAll('.labratgifts-cart-rec-card__form');
    
    addForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(this);
        const button = this.querySelector('button[type="submit"]');
        const originalText = button.innerHTML;
        
        button.disabled = true;
        button.innerHTML = 'Adding...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          button.innerHTML = '✓ Added!';
          button.classList.add('success');
          
          // Update cart count if available
          updateCartCount();
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = originalText;
            button.classList.remove('success');
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          button.disabled = false;
          button.innerHTML = 'Error';
          setTimeout(() => {
            button.innerHTML = originalText;
          }, 2000);
        });
      });
    });
  }

  // Update cart count in header
  function updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Discount code form handler
  function initDiscountForm() {
    const discountForm = document.querySelector('.labratgifts-cart__discount-form');
    if (!discountForm) return;

    discountForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const discountCode = this.querySelector('input[name="discount"]').value;
      
      if (discountCode) {
        // Redirect to checkout with discount code
        window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
      }
    });
  }

  // Smooth scroll to recommendations
  function initRecommendationScroll() {
    const viewAllBtn = document.querySelector('.labratgifts-cart-recommendations__view-all a');
    if (!viewAllBtn) return;

    viewAllBtn.addEventListener('click', function(e) {
      // Optional: Add smooth scroll or analytics tracking
    });
  }

  // Mobile sticky checkout button
  function initMobileStickyCheckout() {
    const stickyButton = document.querySelector('.labratgifts-cart__sticky-checkout');
    const mainCheckoutBtn = document.querySelector('.labratgifts-cart__checkout-btn');
    
    if (!stickyButton || !mainCheckoutBtn) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateStickyButton() {
      const mainBtnRect = mainCheckoutBtn.getBoundingClientRect();
      const isMainBtnVisible = mainBtnRect.top >= 0 && mainBtnRect.bottom <= window.innerHeight;
      const isScrollingDown = window.scrollY > lastScrollY;
      const hasScrolled = window.scrollY > 200;

      // Show sticky button when:
      // - User has scrolled down more than 200px
      // - Main checkout button is not visible
      // - On mobile (handled by CSS)
      if (hasScrolled && !isMainBtnVisible) {
        stickyButton.classList.add('visible');
      } else {
        stickyButton.classList.remove('visible');
      }

      lastScrollY = window.scrollY;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyButton);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll);
    
    // Initial check
    updateStickyButton();
  }

  // Initialize all cart features
  function init() {
    initQuantityControls();
    initShippingProgress();
    initGiftMessage();
    initRecommendationQuickAdd();
    initDiscountForm();
    initRecommendationScroll();
    initMobileStickyCheckout();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
